import React from "react";

import { LogoutIcon } from "2g-auth";
import { LangSwitchRow, LangSwitchItem } from "2g-intl";
import { LANGUAGE } from "2g-i18n";

import NotifikaceIcon from "b2b/components/notifikace/NotifikaceIcon";
import UserInfoIcon from "b2b/components/user-info-icon/UserInfoIcon";

function AppControl() {
  return (
    <div className="b2b-AppControl">
      <NotifikaceIcon />
      <LangSwitchRow>
        <LangSwitchItem lang={LANGUAGE.CZECH}>{LANGUAGE.CZECH}</LangSwitchItem>
        <LangSwitchItem lang={LANGUAGE.ENGLISH}>
          {LANGUAGE.ENGLISH}
        </LangSwitchItem>
      </LangSwitchRow>
      <UserInfoIcon />
      <LogoutIcon />
    </div>
  );
}

export default React.memo(AppControl);
